class KCVS.Models.ProcurementDocument extends Backbone.Model
